import {
  type AvatarAnimationMapping,
  type ViewerAvatarApi,
  type ViewerAvatarState,
} from '@mindcloudxai/shared';
import type { ViewerContext } from '../types';

export function createAvatarApi(getCtx: () => ViewerContext): ViewerAvatarApi {
  return {
    getState: () => getAvatarState(getCtx()),
    setEnabled: (enabled) => setAvatarEnabled(getCtx(), enabled),
    setUrl: (url) => setAvatarUrl(getCtx(), url),
    setFollowCamera: (enabled) => setAvatarFollowCamera(getCtx(), enabled),
    setMapping: (mapping) => setAvatarMapping(getCtx(), mapping),
  };
}

function getAvatarState(ctx: ViewerContext): ViewerAvatarState | null {
  if (!ctx.global) return null;
  const state = ctx.global.state;
  return {
    enabled: state.avatarEnabled ?? false,
    available: state.avatarAvailable ?? false,
    loading: state.avatarLoading ?? false,
    url: state.avatarUrl ?? '',
    status: state.avatarStatus ?? '',
    animations: [...(state.avatarAnimations ?? [])],
    currentAnimation: state.avatarCurrentAnimation ?? '',
    followCamera: state.avatarFollowCamera ?? true,
  };
}

function setAvatarEnabled(ctx: ViewerContext, enabled: boolean): void {
  if (!ctx.global) return;
  ctx.global.state.avatarEnabled = enabled;
}

function setAvatarUrl(ctx: ViewerContext, url: string): void {
  if (!ctx.global) return;
  ctx.global.events.fire('avatarLoadUrl', url);
}

function setAvatarFollowCamera(ctx: ViewerContext, enabled: boolean): void {
  if (!ctx.global) return;
  ctx.global.state.avatarFollowCamera = enabled;
}

function setAvatarMapping(ctx: ViewerContext, mapping: Partial<AvatarAnimationMapping>): void {
  if (!ctx.global) return;
  ctx.global.events.fire('avatarMappingChanged', {
    ...ctx.global.state.avatarMapping,
    ...mapping,
  });
}
